import axiosInstance from './axios-interceptor';

// Create a new question
const createQuestion = (dataToPost) => {
    return axiosInstance.post("/api/questions/create", dataToPost, {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};

// Get all questions with optional filters
const getAllQuestions = (filters = {}) => {
    return axiosInstance.get("/api/questions/list", {
        params: {
            ...filters, // isActive, type
        },
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};

// Get question by ID
const getQuestionById = (questionId) => {
    return axiosInstance.get(`/api/questions/${questionId}`, {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};

// Update question
const updateQuestion = (questionId, dataToUpdate) => {
    return axiosInstance.put(`/api/questions/update/${questionId}`, dataToUpdate, {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};

// Toggle question status (active/inactive)
const toggleQuestionStatus = (questionId) => {
    return axiosInstance.patch(`/api/questions/toggle-status/${questionId}`, {}, {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};

// Delete question
const deleteQuestion = (questionId) => {
    return axiosInstance.delete(`/api/questions/delete/${questionId}`, {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};


// Bulk create questions
const bulkCreateQuestions = (questionsArray) => {
    return axiosInstance.post("/api/questions/bulk-create", {
        questions: questionsArray
    }, {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};

// Reorder questions
const reorderQuestions = (questionIds) => {
    return axiosInstance.post("/api/questions/reorder", {
        questionIds: questionIds
    }, {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};


// Export all functions
export {
    createQuestion,
    getAllQuestions,
    getQuestionById,
    updateQuestion,
    toggleQuestionStatus,
    deleteQuestion,
    bulkCreateQuestions,
    reorderQuestions,
};
